import type { Allergen } from "./types"

/**
 * Canonical localized labels for every EU regulatory allergen. Both apps
 * (business + public-web) and the PDF renderer consume this single source so
 * the labels cannot drift between surfaces. App-specific copy (input
 * placeholders, empty states, pluralization markers, etc.) stays per-app —
 * only the allergen label vocabulary itself lives here.
 */

type Labels = Record<Allergen, string>

export const ALLERGEN_LABELS_EN: Labels = {
	gluten: "Gluten",
	crustaceans: "Crustaceans",
	eggs: "Egg",
	fish: "Fish",
	peanuts: "Peanuts",
	soybeans: "Soy",
	milk: "Milk",
	nuts: "Nuts",
	celery: "Celery",
	mustard: "Mustard",
	sesame: "Sesame",
	sulphur: "Sulfur dioxide",
	lupin: "Lupins",
	molluscs: "Clams",
}

export const ALLERGEN_LABELS_IT: Labels = {
	gluten: "Glutine",
	crustaceans: "Crostacei",
	eggs: "Uova",
	fish: "Pesce",
	peanuts: "Arachidi",
	soybeans: "Soia",
	milk: "Latte",
	nuts: "Frutta a guscio",
	celery: "Sedano",
	mustard: "Senape",
	sesame: "Sesamo",
	sulphur: "Anidride solforosa",
	lupin: "Lupini",
	molluscs: "Molluschi",
}

export const ALLERGEN_LABELS_FR: Labels = {
	gluten: "Gluten",
	crustaceans: "Crustacés",
	eggs: "Oeufs",
	fish: "Poisson",
	peanuts: "Arachides",
	soybeans: "Soja",
	milk: "Lait",
	nuts: "Fruits à coque",
	celery: "Céleri",
	mustard: "Moutarde",
	sesame: "Sésame",
	sulphur: "Sulfites",
	lupin: "Lupin",
	molluscs: "Mollusques",
}

export const ALLERGEN_LABELS_DE: Labels = {
	gluten: "Gluten",
	crustaceans: "Krustentiere",
	eggs: "Ei",
	fish: "Fisch",
	peanuts: "Erdnüsse",
	soybeans: "Soja",
	milk: "Milch",
	nuts: "Nüsse",
	celery: "Sellerie",
	mustard: "Senf",
	sesame: "Sesam",
	sulphur: "Schwefeldioxid",
	lupin: "Lupinen",
	molluscs: "Weichtiere",
}

export const ALLERGEN_LABELS_ES: Labels = {
	gluten: "Gluten",
	crustaceans: "Crustáceos",
	eggs: "Huevo",
	fish: "Pescado",
	peanuts: "Cacahuetes",
	soybeans: "Soja",
	milk: "Leche",
	nuts: "Frutos secos",
	celery: "Apio",
	mustard: "Mostaza",
	sesame: "Sésamo",
	sulphur: "Dióxido de azufre",
	lupin: "Altramuces",
	molluscs: "Moluscos",
}

export const ALLERGEN_LABELS_PT: Labels = {
	gluten: "Glúten",
	crustaceans: "Crustáceos",
	eggs: "Ovo",
	fish: "Peixe",
	peanuts: "Amendoim",
	soybeans: "Soja",
	milk: "Leite",
	nuts: "Frutos de casca rija",
	celery: "Aipo",
	mustard: "Mostarda",
	sesame: "Sésamo",
	sulphur: "Dióxido de enxofre",
	lupin: "Tremoço",
	molluscs: "Moluscos",
}
